import React, { useState, useEffect } from "react";
import { Bar } from "react-chartjs-2";
import { Grid, Slide } from '@material-ui/core';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { connect } from "react-redux";
import { ApplicationState } from "../../store";
import * as APIStore from "../../store/APIStore";
import BarChartIcon from '@material-ui/icons/BarChart';

type OwnProps = {
    month: number,
    year: number
};

const mapState = (state: ApplicationState) => state.vitalsContext;

type StateProps = ReturnType<typeof mapState>;
type DispatchProps = typeof APIStore.actionCreators;
type AdmitTypeBarChartProps = OwnProps & StateProps & DispatchProps;

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const AdmitTypeBarChart = (props: AdmitTypeBarChartProps) => {
    let {
        PhysicianTypeStats,
        userPracticeCoordinatorProfile,
        APIToken,
        requestCurrentUserCareCoordinatorProfile,
        requestAdmitTypeStatsForProviderByMonth,
        month,
        year,
    } = props;

    const [tokenState, setTokenState] = useState<APIStore.TokenType | undefined>();

    useEffect(() => {
        if (APIToken && !tokenState?.accessToken) {
            setTokenState(APIToken);
        }
    }, [APIToken, tokenState]);

    useEffect(() => {
        if (userPracticeCoordinatorProfile) {
            let { isErrored, notFound, isLoaded } = userPracticeCoordinatorProfile
            if ((!isErrored && !notFound && !isLoaded) && tokenState?.accessToken) {
                requestCurrentUserCareCoordinatorProfile(tokenState.accessToken);

            } else {
                if (isLoaded && tokenState?.accessToken) {
                    let coordinatorProfile = userPracticeCoordinatorProfile.coordinatorProfile;

                    // Update Admit Type Stats
                    if (!PhysicianTypeStats.isLoaded && !PhysicianTypeStats.isLoading) {
                        requestAdmitTypeStatsForProviderByMonth(tokenState.accessToken, month, year);
                    }
                }

            }
        }

    }, [tokenState, userPracticeCoordinatorProfile.coordinatorProfile]);

    if (!PhysicianTypeStats || PhysicianTypeStats.isLoading || !PhysicianTypeStats.isLoaded) {
        return (
            <Slide in timeout={1000} direction="right">
                <Grid container>
                    <Grid item md={4}>
                        <BarChartIcon className="animate-flicker" style={{ fontSize: 100 }} color="disabled" />
                    </Grid>
                </Grid>
            </Slide>
        );
    }

    if (PhysicianTypeStats.isErrored) {
        return (<React.Fragment><p>Error Loading</p></React.Fragment>);
    }

    const admits: APIStore.AdmitTypeStatistics[] = PhysicianTypeStats.admitTypeStats;

    const labels = admits.map(val => val.admitType);
    const values = admits.map(val => val.totalAdmits);

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: "top" as const,
            },
            title: {
                display: true,
                text: "Admissions by Type",
            },
        },
    };

    const data = {
        labels,
        datasets: [
            {
                label: "Total Admits",
                data: values,
                backgroundColor: "rgba(82, 189, 228, 0.6)",
                borderColor: "rgba(82, 189, 228, 1)",
                borderWidth: 1,
            },
        ],
    };

    return (
        <React.Fragment>
            <Grid item xs={12} direction="column" container>
                <Grid item xs={12}>
                    <Bar options={options} data={data} />
                </Grid>
            </Grid>
        </React.Fragment>
    );
};

export default connect<StateProps, DispatchProps, OwnProps, ApplicationState>(
    (state: ApplicationState) => state.vitalsContext,
    APIStore.actionCreators
)(AdmitTypeBarChart as any);
